class ReconRedeem extends HTMLElement {
	constructor() {
		super();
		this.serverUrl = this.getServerUrl();
		this.state = {
			loading: false,
			balancePoints: 0,
			loyaltyProfileId: null,
			pageInfo: { hasNextPage: false, hasPreviousPage: false, startCursor: null, endCursor: null },
			pageSize: 5,
		};
		this.els = {
			balance: null,
			input: null,
			button: null,
			message: null,
			birthdayCard: null,
			birthdayInput: null,
			birthdayButton: null,
			birthdayMessage: null,
			historyBody: null,
			tableWrap: null,
			pagination: null,
			prevBtn: null,
			nextBtn: null,
		};
		this.isCartEmpty = true;
		this.onRedeem = this.onRedeem.bind(this);
		this.onBirthdaySave = this.onBirthdaySave.bind(this);
		this.fetchBalance = this.fetchBalance.bind(this);
		this.fetchGiftCards = this.fetchGiftCards.bind(this);
		this.renderGiftCards = this.renderGiftCards.bind(this);
		this.updatePaginationUI = this.updatePaginationUI.bind(this);
		this.loadPage = this.loadPage.bind(this);
		this.cartValidate = this.cartValidate.bind(this);

	}

	getServerUrl() {
		return "/apps/recon-loyalty-api/";
		// const ctx = this.getCtx();
		// const apiRoot = ctx?.environment === "dev" ? ctx?.devUrl : ctx?.prodUrl || "";
		// if (!apiRoot) {
		// 	throw new Error("API root not found");
		// }
		// return apiRoot;
	}

	connectedCallback() {
		this.els.balance = this.querySelector("#recon-balance-points");
		this.els.input = this.querySelector("#recon-points-input");
		this.els.button = this.querySelector("#app--recon-redeem-btn");
		this.els.message = this.querySelector("#app--recon-redeem-message");
		this.els.birthdayCard = this.querySelector(".app--recon-birthday-card");
		this.els.birthdayInput = this.querySelector("#recon-birthday-input");
		this.els.birthdayButton = this.querySelector("#app--recon-birthday-btn");
		this.els.birthdayMessage = this.querySelector("#app--recon-birthday-message");
		// Hide birthday card by default; will show only if dateOfBirth is null
		if (this.els.birthdayCard) this.els.birthdayCard.style.display = "none";
		this.els.historyBody = this.querySelector("#recon-history-body");
		this.els.tableWrap = this.querySelector(".app--recon-table-wrap");

		if (this.els.tableWrap && !this.els.pagination) {
			const pagination = document.createElement("div");
			pagination.className = "app--recon-pagination";
			const prevBtn = document.createElement("button");
			prevBtn.type = "button";
			prevBtn.className = "app--recon-page-btn";
			prevBtn.setAttribute("aria-label", "Previous page");
			prevBtn.innerHTML = `<svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.7803 5.46967C12.0732 5.76256 12.0732 6.23744 11.7803 6.53033L8.31066 10L11.7803 13.4697C12.0732 13.7626 12.0732 14.2374 11.7803 14.5303C11.4874 14.8232 11.0126 14.8232 10.7197 14.5303L6.71967 10.5303C6.42678 10.2374 6.42678 9.76256 6.71967 9.46967L10.7197 5.46967C11.0126 5.17678 11.4874 5.17678 11.7803 5.46967Z" fill="currentColor"/>
            </svg>`;
			const nextBtn = document.createElement("button");
			nextBtn.type = "button";
			nextBtn.className = "app--recon-page-btn";
			nextBtn.setAttribute("aria-label", "Next page");
			nextBtn.innerHTML = `<svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.71967 14.5303C7.42678 14.2374 7.42678 13.7626 7.71967 13.4697L11.1893 10L7.71967 6.53033C7.42678 6.23744 7.42678 5.76256 7.71967 5.46967C8.01256 5.17678 8.48744 5.17678 8.78033 5.46967L12.7803 9.46967C13.0732 9.76256 13.0732 10.2374 12.7803 10.5303L8.78033 14.5303C8.48744 14.8232 8.01256 14.8232 7.71967 14.5303Z" fill="currentColor"/>
            </svg>`;
			pagination.appendChild(prevBtn);
			pagination.appendChild(nextBtn);
			this.els.tableWrap.appendChild(pagination);
			this.els.pagination = pagination;
			this.els.prevBtn = prevBtn;
			this.els.nextBtn = nextBtn;
		}

		if (this.els.button) this.els.button.addEventListener("click", this.onRedeem);
		if (this.els.birthdayButton) this.els.birthdayButton.addEventListener("click", this.onBirthdaySave);
		if (this.els.prevBtn) this.els.prevBtn.addEventListener("click", () => this.loadPage("prev"));
		if (this.els.nextBtn) this.els.nextBtn.addEventListener("click", () => this.loadPage("next"));
		this.fetchBalance();
	}

	disconnectedCallback() {
		if (this.els.button) this.els.button.removeEventListener("click", this.onRedeem);
		if (this.els.birthdayButton) this.els.birthdayButton.removeEventListener("click", this.onBirthdaySave);
	}

	getCtx() {
		return window.reConLoyaltyProgram || {};
	}

	setMessage(text, tone = "info") {
		if (!this.els.message) return;
		this.els.message.textContent = text || "";
		this.els.message.style.color = tone === "error" ? "#b91c1c" : tone === "success" ? "#065f46" : "#374151";
	}

	setMessageTo(element, text, tone = "info") {
		if (!element) return;
		element.textContent = text || "";
		element.style.color = tone === "error" ? "#b91c1c" : tone === "success" ? "#065f46" : "#374151";
	}

	setLoading(isLoading) {
		this.state.loading = isLoading;
		if (this.els.button) this.els.button.disabled = isLoading;
	}

	formatCurrency(amount) {
		const ctx = this.getCtx();
		const template = ctx?.moneyFormat || "${{amount}}";
		const value = Number(amount) || 0;

		const formattedNumber = new Intl.NumberFormat("en-US", {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		}).format(value);

		if (/{{\s*amount\s*}}/.test(template)) {
			return template.replace(/{{\s*amount\s*}}/, formattedNumber);
		}

		return formattedNumber;
	}

	async fetchBalance() {
		try {
			const ctx = this.getCtx();
			if (!ctx.shopDomain || !ctx.customerEmail) return;

			const params = new URLSearchParams({
				shopDomain: ctx.shopDomain,
				pageSize: String(this.state.pageSize),
			});

			const resp = await fetch(`${this.serverUrl}giftcard-listing?${params.toString()}`);
			// const resp = await fetch(`${this.serverUrl}giftcard-listing`);
			const payload = await resp.json();
			if (payload?.statusCode !== 200) {
				this.state.balancePoints = Number(this.els.balance?.textContent || 0) || 0;
				if (this.els.balance) this.els.balance.textContent = this.state.balancePoints?.toLocaleString() || 0;
				// Keep birthday card hidden by default on non-200
				if (this.els.birthdayCard) this.els.birthdayCard.style.display = "none";
				return;
			}

			const loyaltyProfile = payload?.loyaltyProfile;
			if (loyaltyProfile) {
				this.state.balancePoints = loyaltyProfile.currentPoints || 0;
				this.state.loyaltyProfileId = loyaltyProfile.id || null;
				// Toggle birthday card visibility based on dateOfBirth presence
				// const hasDob = !!loyaltyProfile?.dateOfBirth;
				// const isDobRuleEnable = payload?.isBirthdayRuleEnabled
				// if (this.els.birthdayCard) {
				// 	this.els.birthdayCard.style.display = hasDob ? "none" : "";
				// }
				const hasDob = Boolean(loyaltyProfile?.dateOfBirth);
				const isDobRuleEnable = payload?.isBirthdayRuleEnabled;

				if (this.els.birthdayCard) {
					if (isDobRuleEnable) {
						// Birthday rule is enabled → show card ONLY if DOB is missing
						this.els.birthdayCard.style.display = hasDob ? "none" : "block";
					} else {
						// Birthday rule disabled → always hide card
						this.els.birthdayCard.style.display = "none";
					}
				}
			} else {
				this.state.balancePoints = 0;
				this.state.loyaltyProfileId = null;
				// If no profile, keep birthday card hidden by default
				if (this.els.birthdayCard) this.els.birthdayCard.style.display = "none";
			}

			if (this.els.balance) this.els.balance.textContent = (this.state.balancePoints ?? 0).toLocaleString();

			const items = Array.isArray(payload?.data) ? payload.data : [];
			await this.cartValidate();
			this.renderGiftCards(items);
			this.state.pageInfo = payload?.pageInfo || { hasNextPage: false, hasPreviousPage: false, startCursor: null, endCursor: null };
			this.updatePaginationUI();
		} catch (e) {
			this.state.balancePoints = Number(this.els.balance?.textContent || 0) || 0;
			if (this.els.balance) this.els.balance.textContent = this.state.balancePoints?.toLocaleString() || 0;
		}
	}

	async onRedeem() {
		const ctx = this.getCtx();
		const raw = this.els.input?.value;
		const points = Number(raw);
		if (!Number.isFinite(points) || points <= 0) {
			this.setMessage("Enter a valid number of points", "error");
			return;
		}
		if (!ctx.shopDomain || !ctx.customerEmail) {
			this.setMessage("Missing shop or customer details", "error");
			return;
		}

		this.setLoading(true);
		this.setMessage("");
		try {
			// if (!window.api) {
			//   this.setMessage("API client not ready. Please refresh.", "error");
			//   return;
			// }

			const result = await fetch(`${this.serverUrl}redeem-points`, {
				method: "POST",
				body: JSON.stringify({
					shopDomain: ctx.shopDomain,
					// customerEmail: ctx.customerEmail,
					redeemPoints: points,
				}),
				headers: {
					"Content-Type": "application/json",
				},
			});

			const data = await result.json();
			if (data.statusCode !== 200) {
				this.setMessage(data.message || "Redemption failed. Please try again.", "error");
				return;
			}

			this.setMessage(data.message || "Redemption successful! Check your email for the gift card.", "success");
			this.els.input.value = "";
			this.fetchBalance();
		} catch (error) {
			const errorMessage = error?.message || "Redemption failed. Please try again.";
			this.setMessage(errorMessage, "error");
		} finally {
			this.setLoading(false);
		}
	}

	async onBirthdaySave() {
		const ctx = this.getCtx();
		const birthday = this.els.birthdayInput?.value;
		if (!birthday) {
			this.setMessageTo(this.els.birthdayMessage, "Enter a valid birthday", "error");
			return;
		}
		if (!ctx.shopDomain) {
			this.setMessageTo(this.els.birthdayMessage, "Missing shop or customer details", "error");
			return;
		}
		const btn = this.els.birthdayButton;
		if (btn) btn.disabled = true;
		this.setMessageTo(this.els.birthdayMessage, "");
		try {
			const result = await fetch(`${this.serverUrl}birthday`, {
				method: "POST",
				body: JSON.stringify({
					shopDomain: ctx.shopDomain,
					// customerEmail: ctx.customerEmail,
					birthday: birthday,
				}),
				headers: {
					"Content-Type": "application/json",
				},
			});
			const data = await result.json();
			if (data.statusCode !== 200) {
				this.setMessageTo(this.els.birthdayMessage, data.message || "Birthday save failed. Please try again.", "error");
				return;
			}
			this.setMessageTo(this.els.birthdayMessage, data.message || "Birthday saved successfully!", "success");
		} catch (error) {
			const errorMessage = error?.message || "Birthday save failed. Please try again.";
			this.setMessageTo(this.els.birthdayMessage, errorMessage, "error");
		} finally {
			if (btn) btn.disabled = false;
		}
	}

	async fetchGiftCards({ startCursor, endCursor } = {}) {
		try {
			console.log("fetchGiftCards")
			if (!this.els.historyBody) return;
			const ctx = this.getCtx();
			if (!ctx.shopDomain || !ctx.customerEmail) return;

			const params = new URLSearchParams({
				shopDomain: ctx.shopDomain,
				pageSize: this.state.pageSize,
			});
			if (endCursor) params.set("endCursor", endCursor);
			if (startCursor) params.set("startCursor", startCursor);

			const resp = await fetch(`${this.serverUrl}giftcard-listing?${params.toString()}`);
			const payload = await resp.json();
			if (payload?.statusCode !== 200) {
				return;
			}

			await this.cartValidate();

			const items = Array.isArray(payload?.data) ? payload.data : [];
			this.renderGiftCards(items);
			this.state.pageInfo = payload?.pageInfo || { hasNextPage: false, hasPreviousPage: false, startCursor: null, endCursor: null };
			this.updatePaginationUI();
		} catch (error) {
		}
	}

	async cartValidate() {
		try {
			const response = await fetch('/cart.js', {
				method: 'GET',
				headers: {
					'Accept': 'application/json'
				}
			});

			const cart = await response.json();

			this.isCartEmpty = !cart.items || cart.items.length === 0;

			console.log("Cart Data:========================>", cart);
			console.log("Cart Empty:=======================>", this.isCartEmpty);

		} catch (error) {
			console.log("Cart Error:", error);
			this.isCartEmpty = true;
		}
	}

	renderGiftCards(items) {
		this.els.historyBody.innerHTML = "";
		// const items = []

		// If no items → show empty row
		if (!items || items.length === 0) {
			const tr = document.createElement("tr");
			tr.innerHTML = `
				<td colspan="4" style="text-align:center; padding: 12px; color:#666;">
					No gift cards found
				</td>`;
			this.els.historyBody.appendChild(tr);
			return;
		}

		for (const tx of items || []) {
			if (!tx?.giftcard) {
				continue;
			}

			const redeemedPoints = tx?.data?.redeemedPoints != null ? '-' + tx.data.redeemedPoints : '—';
			const giftAmount = Number(tx?.giftcard?.initialValue?.amount) || 0;
			const amountLeft = Number(tx?.giftcard?.balance?.amount) || 0;

			const code = tx?.giftcard?.giftCardCode || tx?.giftcard?.lastCharacters || "-";

			const isFullyUsed = amountLeft <= 0;

			const tr = document.createElement("tr");

			tr.innerHTML = `
				<td>${redeemedPoints}</td>
				<td>${this.formatCurrency(giftAmount)}</td>
				<td>${this.formatCurrency(amountLeft)}</td>
				<td><span class="app--recon-code-link">${code}</span></td>
				<td>
					${
						isFullyUsed
							? `<p class="app--recon-apply-emptyCart-text">Fully Used</p>`
							: this.isCartEmpty
							? `<p class="app--recon-apply-emptyCart-text">Add products to cart to apply</p>`
							: `<button type="button" class="app--recon-apply-discount-btn">Apply & Go To Checkout</button>`
					}
				</td>
			`;

			
			if (!this.isCartEmpty && !isFullyUsed) {
				const btn = tr.querySelector(".app--recon-apply-discount-btn");
				btn.addEventListener("click", () => {
					this.applyDiscountCode(code);
				});
			}

			this.els.historyBody.appendChild(tr);
		}
	}

	isGiftCardFullyUsed(balance) {
		return parseFloat(balance) <= 0;
	}

	applyDiscountCode(discountCode) {
		window.location.href = `/checkout?discount=${ discountCode }`;
	}

	updatePaginationUI() {
		if (!this.els.prevBtn || !this.els.nextBtn) return;
		const { hasNextPage, hasPreviousPage } = this.state.pageInfo || {};
		this.els.prevBtn.disabled = !hasPreviousPage;
		this.els.nextBtn.disabled = !hasNextPage;
	}

	async loadPage(direction) {
		const { startCursor, endCursor } = this.state.pageInfo || {};
		if (direction === "next" && endCursor) return this.fetchGiftCards({ endCursor });
		if (direction === "prev" && startCursor) return this.fetchGiftCards({ startCursor });
	}
}
customElements.define("app--recon-redeem", ReconRedeem);


// // Detect Shopify cart updates
const originalFetch = window.fetch;

window.fetch = async (...args) => {
	const response = await originalFetch(...args);
	const url = typeof args[0] === "string" ? args[0] : args[0]?.url;
	if (
		url &&
		(
		// url.includes("/cart/add.js") ||
		url.includes("/cart/change") ||
		url.includes("/cart/update") ||
		url.includes("/cart/clear")
		)
	) {
		console.log("==================cdcdcdc=cd=================")
		document.dispatchEvent(new CustomEvent("recon:cart-updated"));
	}

//   if (typeof args[0] === "string" && args[0].includes("/cart")) {
// 	console.log("==================cdcdcdc=cd=================")
//     // document.dispatchEvent(new CustomEvent("recon:cart-updated"));
//   }

  return response;
};


// // Listen cart updates
document.addEventListener("recon:cart-updated", () => {

	const component = document.querySelector("app--recon-redeem");

	if (!component) return;

	component.cartValidate().then(() => {
		component.fetchBalance();
	});

});

// function defineReconElement() {
//   if (customElements.get("app--recon-redeem")) return;
// }

// if (window.reconLiquidReady) {
//   defineReconElement();
// } else {
//   window.addEventListener('recon:liquid-ready', defineReconElement, { once: true });
// }